import * as UUID from 'uuid';

export const SENDER_ID = UUID.v4();
